import { render, staticRenderFns } from "./ServiceDeviceRepairTechnicalReport.vue?vue&type=template&id=130a4f89&"
import script from "./ServiceDeviceRepairTechnicalReport.vue?vue&type=script&lang=js&"
export * from "./ServiceDeviceRepairTechnicalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports